var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOffsiteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40860_3282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 18.875H9.88645C9.8558 18.5875 9.84009 18.2956 9.84009 18C9.84009 16.2288 10.4044 14.5894 11.363 13.2518C10.3691 12.4173 9.20637 12 7.875 12H1.8C1.80001 6.36669 6.3667 1.8 12 1.8C12.7144 1.8 13.4117 1.87345 14.0847 2.01322C13.9858 2.12147 13.8927 2.23657 13.8054 2.3585C13.5185 2.75908 13.375 3.22291 13.375 3.75H12C11.2447 3.75091 10.5975 4.02041 10.0585 4.5585C9.5195 5.09658 9.25 5.74375 9.25 6.49999V9.24999H14.75V10.5129C15.7459 10.0801 16.8449 9.84003 18.0001 9.84003C20.3682 9.84003 22.5007 10.8488 23.9913 12.4601C23.9971 12.3074 24 12.1541 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.1541 24 12.3075 23.9971 12.4602 23.9913C11.8796 23.4542 11.3772 22.8337 10.972 22.1488C10.3817 22.0898 9.80627 21.9804 9.25 21.825V18.875Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18ZM19.8048 17.0403L15.8451 21L15 20.1549L18.9597 16.1952H16.4185V15H21V19.9135H19.8048V17.0403Z",
    fill: "var(--primary-6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40860_3282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsiteFilled);
export default __webpack_public_path__ + "static/media/offsiteFilled.2c8056a66b265f51d5fb5c42f9fee8aa.svg";
export { ForwardRef as ReactComponent };